import React, { FC } from 'react';
import useMiniCard from 'hooks/useMiniCard';
import MobileSlider from 'generic/MobileSlider2';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks/useStores';
import { MultiplePrewievContainer, MobileContainer, MobileContent } from './ImageStyles';
import MultiplePrewiev from './components/MultiplePrewiev';

const Image: FC = observer(() => {
  const {
    appStore: { isMobile, screenClassNames },
  } = useStores();

  const {
    data: {
      advert: { photos, isPurchase },
    },
  } = useMiniCard();

  if (isPurchase) return null;

  return isMobile ? (
    <MobileContainer>
      <MobileContent>
        <MobileSlider photos={photos} />
      </MobileContent>
    </MobileContainer>
  ) : (
    <MultiplePrewievContainer className={screenClassNames}>
      <MultiplePrewiev photos={photos} />
    </MultiplePrewievContainer>
  );
});

export default Image;
